const restBase = '/circulation-proxy/rest/circulation';

const postOptions = data => ({
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    ...data
  })
});

const getInstitutionInformation = (tenant, locale) =>
  _fetchData(
    `${restBase}/get-institution-information?tenant_id=${tenant}&language=${locale.language}-${locale.country}`,
    postOptions({ institutionId: '1' })
  );

const getUploadLimitations = tenant =>
  _fetchData(`${restBase}/online-registration/file-upload/limitations?tenant_id=${tenant}`);

const getTenantFormFields = (tenant, locale) =>
  _fetchData(
    `${restBase}/get-online-registration-fields?language=${locale.language}_${locale.country}&tenant_id=${tenant}`
  );

const activateRegistration = ({ tenantId, uuid }) =>
  _fetchData(
    `${restBase}/online-registration-activate?tenant_id=${tenantId}`,
    postOptions({ institutionId: '1', uuid })
  );

const _fetchData = (url, options) =>
  fetch(url, options).then(response => {
    if (response.status >= 400) {
      return Promise.reject(response);
    }
    return response.json();
  });

export default {
  getInstitutionInformation,
  getUploadLimitations,
  getTenantFormFields,
  activateRegistration
};
